import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    SelectInput,
    NullableBooleanInput,
    DateTimeInput,
    FormDataConsumer,
    minValue,
    NumberInput,
} from 'react-admin';

import { EditToolbar } from '../../common/EditToolbar';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';

import { Ecom_Coupons } from '../../custom';
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import { ECOM_COUPON_TYPE } from '../../common/constants';
import { EcomCategoriesAutoComplete } from '../../common/inputs/autoCompleteInputs/EcomCategoriesAutoComplete';
import { EcomProductTemplateAutoComplete } from '../../common/inputs/autoCompleteInputs/EcomProductTemplateAutoComplete';

export const studentProfileRender = (choice: any) => `${choice.name}` || '';

export const filterToQueryStudent = (searchText: string) => ({
    name: `${searchText}%`,
});

const CouponEdit = () => {
    const { isUpdatable } = useIsPermission('COUPONS');
    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit title={<CouponTitle />} mutationMode={'pessimistic'}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="code" fullWidth validate={[required()]} />
                    <SelectInput
                        source="type"
                        label="Type"
                        fullWidth
                        validate={[required()]}
                        choices={ECOM_COUPON_TYPE}
                    />
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            formData.type === 'PERCENTAGE' ? (
                                <>
                                    <NumberInput
                                        source="discountInPercentage"
                                        prefix={'%'}
                                        fullWidth
                                        validate={[minValue(0)]}
                                    />
                                    <NumberInput
                                        source="maxDiscountPrice"
                                        prefix={'₹'}
                                        type={'number'}
                                        validate={[minValue(0)]}
                                        fullWidth
                                    />
                                </>
                            ) : (
                                <NumberInput
                                    source="discountInPrice"
                                    prefix={'₹'}
                                    type={'number'}
                                    validate={[minValue(0), required()]}
                                    fullWidth
                                />
                            )
                        }
                    </FormDataConsumer>
                    <NumberInput source="maxTotalUsages" type={'number'} fullWidth validate={[minValue(0), required()]} />
                    <NumberInput source="maxUsageByPerStudent" type={'number'} fullWidth validate={[minValue(0), required()]} />
                    <EcomCategoriesAutoComplete label="Ecom Category" />
                    <EcomProductTemplateAutoComplete label="Ecom Product Template" />
                    <NullableBooleanInput source={'hidden'} fullWidth />
                    <DateTimeInput source={'startedAt'} validate={[required()]} fullWidth />
                    <DateTimeInput source={'expiringAt'} fullWidth validate={[required()]} />
                    <HTMLEditorInput
                        source={'description'}
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    );
};

const CouponTitle = () => {
    const record = useRecordContext<Ecom_Coupons>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.coupons.name', { smart_count: 1 })} &quot;
            {record.code}&quot;
        </span>
    ) : null;
};

export default CouponEdit;
